import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews';

import { ThemeProvider } from '@emotion/react';
import { theme } from './src/theme';

import { UserTypeProvider } from './src/context/userContext';
import { linkResolver } from './src/utils/linkResolver';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      <UserTypeProvider type="entrepreneur">{element}</UserTypeProvider>
    </ThemeProvider>
  );
};

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider
    repositoryConfigs={[
      {
        repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME!,
        linkResolver: linkResolver,
      },
    ]}
  >
    {element}
  </PrismicPreviewProvider>
);
